"use client";

import { Badge } from "@oreme/ui";
import { useAtom } from "jotai";
import { useLocale } from "next-intl";
import React, { type ReactElement, useState } from "react";
import { selectedTagIdsAtom } from "@/store/devices";
import type { Tag } from "@/types";

interface DevicesTagListProps {
  tags: Tag[];
}

function DevicesTagList({
  tags,
}: Readonly<DevicesTagListProps>): ReactElement | null {
  const locale = useLocale();
  const [mounted] = useState(() => globalThis.window !== undefined);
  const [selectedTagIds, setSelectedTagIds] = useAtom(selectedTagIdsAtom);

  const toggleTag = (id: number) => {
    setSelectedTagIds((prev) =>
      prev.includes(id) ? prev.filter((tagId) => tagId !== id) : [...prev, id],
    );
  };

  if (!mounted) return null;

  return (
    <ul className="flex flex-wrap">
      {tags.map((tag: Tag) => {
        const isActive = selectedTagIds.includes(tag.id);
        return (
          <li key={tag.id}>
            <button
              onClick={() => {
                toggleTag(tag.id);
              }}
              type="button"
            >
              <Badge className={isActive ? "text-white bg-blue-700" : ""}>
                {tag.name[locale]}
              </Badge>
            </button>
          </li>
        );
      })}
    </ul>
  );
}

export { DevicesTagList, type DevicesTagListProps };
